import type { DrugCard } from './types';

export const drugCards: DrugCard[] = [
  {
    no: "МК-2026-0089",
    substance: "Метамфетамин",
    substanceId: "meth",
    amount: "182.4 g",
    purity: "78.2%",
    seizureDate: "2026-03-19 06:40",
    placeKo: "바양주르흐구 13구역 주거지",
    placeMn: "Баянзүрх дүүрэг, 13-р хороо, орон сууц",
    analysis: "done",
    value: "₮ 547,200,000",
    created: "2026-03-19",
  },
  {
    no: "МК-2026-0090",
    substance: "Каннабис",
    substanceId: "cannabis",
    amount: "56.0 g",
    purity: "—",
    seizureDate: "2026-03-19 06:40",
    placeKo: "동일 장소 차량 내부",
    placeMn: "Мөн газар, автомашин дотроос",
    analysis: "pending",
    value: "₮ 28,000,000",
    created: "2026-03-19",
  },
];
